
// import { ImageItem } from "@school/a2z-lib";

export const LogoPath = './assets/media/logos/maven-practice-app.svg';
export const UserimgPath = './assets/media/users/';
export const EditIconPath = './assets/media/svg/icons/Communication/Write.svg';
export const DeleteIconPath = './assets/media/svg/icons/General/Trash.svg';
export const CloseIconPath = './assets/media/svg/icons/Navigation/Close.svg';
export const UserIconPath = './assets/media/svg/icons/General/User.svg';
export const PwdIconPath = './assets/media/svg/icons/General/Shield-protected.svg';
export const GroupuserIconPath = './assets/media/svg/icons/Communication/Group.svg';
export const TwofaIconPath = './assets/media/svg/icons/General/Shield-check.svg';
export const CommunicationPath = './assets/media/svg/icons/Communication/Sending mail.svg';
export const ChatIconPath = './assets/media/svg/icons/Communication/Chat2.svg';
export const StartIconPath = './assets/media/svg/icons/Media/Play.svg';
export const ResumeIconPath = './assets/media/svg/icons/Media/Repeat.svg';
export const StopIconPath = './assets/media/svg/icons/Code/Stop.svg';
export const CallIconPath = './assets/media/svg/icons/Communication/Call.svg';
export const AvailableIconPath = './assets/media/svg/icons/a2z/available.svg';
export const unAvailableIconPath = './assets/media/svg/icons/a2z/unavailable.svg';
export const TelconsultIconPath = './assets/media/svg/icons/Media/teleconsult.svg';
